export default __webpack_public_path__ + "static/media/rainbow.8c443963.png";